import { CustomerLoginPage } from '@/pages/customer-portal/auth/CustomerLoginPage';
import { createFileRoute, useSearch } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
	redirect: z.string().optional(),
	// Set by the portal account-deletion flow so login can confirm the wipe after the hard redirect.
	deleted: z.literal('1').optional(),
});

export const Route = createFileRoute('/customer/login')({
	validateSearch: searchSchema,
	component: CustomerLoginRoute,
});

function CustomerLoginRoute() {
	const { redirect, deleted } = useSearch({ from: '/customer/login' });
	return <CustomerLoginPage redirect={redirect} accountDeleted={deleted === '1'} />;
}
